<template>
	<Tabs v-model="chatStore.chatViewMode" :options="switcherOptions"></Tabs>
</template>

<script setup lang="ts">
import Tabs from './Tabs.vue'
import { useChatStore } from '@/stores/chatStore'
const chatStore = useChatStore()

const switcherOptions = [
	{
		id: 'active',
		text: 'Aktivní'
	},
	{
		id: 'archive',
		text: 'Archivované'
	}
]
</script>

<style scoped></style>
